import { lazy } from 'react';

export const ObjectDetailsPage = lazy(() =>
  import('./ui/ObjectDetailsPage').then((module) => ({
    default: module.ObjectDetailsPage,
  }))
);
